"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuState = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var MenuState = /** @class */ (function (_super) {
    tslib_1.__extends(MenuState, _super);
    function MenuState(props) {
        var _this = _super.call(this, props) || this;
        _this.isControlled = function () {
            return typeof _this.props.opened === "boolean";
        };
        _this.onOpenedChange = function (openedChangeParams) {
            _this.setState({ opened: openedChangeParams.opened }, function () {
                if (_this.props.onOpenedChange) {
                    _this.props.onOpenedChange(openedChangeParams);
                }
            });
        };
        _this.state = {
            opened: _this.isControlled() ? _this.props.opened : _this.props.defaultOpened,
        };
        return _this;
    }
    MenuState.prototype.render = function () {
        var _a;
        return this.props.children({
            opened: (_a = (this.isControlled() ? this.props.opened : this.state.opened)) !== null && _a !== void 0 ? _a : false,
            onOpenedChange: this.onOpenedChange,
        });
    };
    MenuState.defaultProps = {
        defaultOpened: false,
    };
    return MenuState;
}(react_1.default.Component));
exports.MenuState = MenuState;
//# sourceMappingURL=MenuState.js.map